import React from 'react'
import StockOutItemHeader from './StockOutItemHeader'
import StockOutItemInner from './StockOutItemInner'
import StockOutItemFooter from './StockOutItemFooter'
import { getStockOutByID, saveStockOut, deleteStockOut, restoreStockOut,
  deleteStockInAutoPosted } from '../StockOutFunctions'

export const stockOutItemControllerContext = React.createContext()

function useStockOutItemController(props) {
  const stockOutItem = props.stockOutItem

  const obj = {
    stockOutItem,
    saveStockOut,
    deleteStockOut,
    restoreStockOut,
    deleteStockInAutoPosted,
    getStockOutByID,
  }

  return (obj)
}

function StockOutItemController(props) {
  const stockOutItemController = useStockOutItemController(props)
  return (
    <React.Fragment>
      <stockOutItemControllerContext.Provider value={stockOutItemController}>
        <StockOutItemHeader />
        <StockOutItemInner />
        <StockOutItemFooter />
      </stockOutItemControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(StockOutItemController)